/**
 * Utilidades de fecha con manejo correcto de zona horaria local.
 *
 * Problema: new Date("2026-05-19") se interpreta como medianoche UTC.
 * En Perú (UTC-5) eso equivale a las 7pm del día 18, haciendo que el
 * día 19 aparezca como "hoy" o "vencido" cuando todavía es el 18.
 *
 * Solución: parsear siempre como fecha LOCAL con new Date(y, m-1, d).
 */

/** Hoy como "YYYY-MM-DD" en hora local (nunca UTC). */
export function fechaHoyLocal() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm   = String(d.getMonth() + 1).padStart(2, "0");
  const dd   = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * Parsea "YYYY-MM-DD" como fecha local (00:00:00 hora local).
 * new Date("YYYY-MM-DD") da UTC midnight → bug en UTC-5.
 * new Date(y, m-1, d)   da medianoche local → correcto.
 */
export function parsearFechaLocal(fechaStr) {
  if (!fechaStr) return null;
  const [y, m, d] = String(fechaStr).split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

/**
 * Días entre hoy (local) y una fecha "YYYY-MM-DD".
 * Retorna: negativo = vencido, 0 = hoy, positivo = futuro.
 */
export function diasDesdeHoy(fechaStr) {
  if (!fechaStr) return null;
  const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
  const f   = parsearFechaLocal(fechaStr);
  if (!f) return null;
  return Math.round((f - hoy) / 86400000);
}

/**
 * "YYYY-MM-DD" local de hoy + N días.
 * Uso: nextFollowUpDate = fechaEnNDias(7)
 */
export function fechaEnNDias(n) {
  const d = new Date();
  d.setDate(d.getDate() + n);
  const yyyy = d.getFullYear();
  const mm   = String(d.getMonth() + 1).padStart(2, "0");
  const dd   = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
